import { render, staticRenderFns } from "./ChartClassRank.vue?vue&type=template&id=3f773427&scoped=true&"
import script from "./ChartClassRank.vue?vue&type=script&lang=ts&"
export * from "./ChartClassRank.vue?vue&type=script&lang=ts&"
import style0 from "./ChartClassRank.vue?vue&type=style&index=0&id=3f773427&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f773427",
  null
  
)

export default component.exports